import MockupFilter from './MockupFilter'

export default MockupFilter
